import styled, { css } from "styled-components";
import { H4, Body2 } from "Components/Text";
import { ReactComponent as LogoAthleteDark } from "Assets/Images/POTW_Logo_Dark.svg";
import { ReactComponent as LogoAthleteLight } from "Assets/Images/POTW_Logo_Light.svg";
import FordLogo from "Assets/Images/FordLogo.png";
import { Menu } from "Components/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useClickOutside } from "utils/useClickOutside";
import { getAuth, signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";

export type HeaderProps = {
  homeScreen?: boolean;
};

export const Header = ({ homeScreen }: HeaderProps) => {
  const { pathname } = useLocation();
  const isAdminView = pathname?.includes("admin");
  const navigate = useNavigate();
  const auth = getAuth();
  const [user] = useAuthState(auth);
  const [open, setOpen] = useState(false);
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null);
  useClickOutside(referenceElement, () => setOpen(false));

  const signOutUser = () => {
    signOut(auth)
      .then(() => {
        navigate("/login");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Container homeScreen={homeScreen}>
      <LogoWrapper>
        {homeScreen ? <LogoAthleteLight /> : <LogoAthleteDark />}
      </LogoWrapper>
      {isAdminView ? (
        <Right
        //ref={setReferenceElement}
        >
          <UserAvatar onClick={() => setOpen(!open)}>
            {user?.email?.slice(0, 1).toUpperCase() || "F"}
          </UserAvatar>
          {open && (
            <DropdownMenu>
              <Option
                onClick={() => {
                  navigate("/login", { state: { updatePassword: true } });
                }}
              >
                Update password
              </Option>
              <Option
                onClick={() => {
                  signOutUser();
                }}
              >
                Sign Out
              </Option>
            </DropdownMenu>
          )}
        </Right>
      ) : (
        <Menu homeScreen={homeScreen} />
      )}
    </Container>
  );
};
const Container = styled.div<{ homeScreen?: boolean }>`
  width: 100%;
  max-width: 1440px;
  display: flex;
  padding: 10px 40px 20px 10px;
  align-items: center;
  justify-content: space-between;
  position: ${({ homeScreen }) => homeScreen && "absolute"};
  z-index: 10;
`;
const Title = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  ${({ theme }) => theme.mediaQueries.mobile} {
    display: none;
  }
`;
const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Logo = styled.img<{ isAdmin?: boolean }>`
  width: 100%;
  max-width: 100px;
  object-fit: cover;
`;
export const UserAvatar = styled.div`
  height: 47px;
  width: 47px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 25px;
  text-align: center;
  background: #1700f4;
  border-radius: 50%;
  cursor: pointer;
  user-select: none;
`;
const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
`;
const DropdownMenu = styled.div`
  width: 300px;
  position: absolute;
  top: 105%;
  right: 0;
  z-index: 100;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.16);
  background: #fff;
`;

const Option = styled.div`
  display: block;
  text-decoration: none;
  padding: 8px;
  cursor: pointer;
  user-select: none;
  &:first-child {
    border-bottom: 1px solid #cccccc82;
  }
  &:hover {
    background: #e6e9eb;
  }
`;

const Info = styled.div`
  padding: 8px;
  font-size: 14px;
`;
